import { useCurrentAgent } from "hooks/queries/use-current-agent";
import { useMerchant } from "hooks/queries/use-settings-merchant";
import React from "react";
import { Navigate } from "react-router-dom";
import { canAccessAiChats } from "util/permissions";

interface AiChatsRouteGuardProps {
  redirectTo: string;
  children: React.ReactNode;
}

const AiChatsRouteGuard = ({
  redirectTo,
  children,
}: AiChatsRouteGuardProps) => {
  const { data: currentAgent } = useCurrentAgent();
  const { data: merchant } = useMerchant();

  if (!canAccessAiChats(currentAgent)) {
    return <Navigate to={`/${merchant.id}/${redirectTo}`} replace={true} />;
  }

  return <>{children}</>;
};

export default AiChatsRouteGuard;
